<template>
  <div>
    <el-button type="primary" @click="getSelfData()">统计</el-button>
    <div class="fz-12 inline-block" style="vertical-align: -8px;margin-left:20px;">
      <div>建筑面积(m<sup>2</sup>)：{{schedule_size}}</div>
      <div>工程造价(元)：{{schedule_price}}</div>
    </div>
    <div class="fz-12 inline-block" style="vertical-align: -8px;margin-left:20px;">
      <div>自开始建设至本月汇计完成(万元): {{schedule_sum}}</div>
      <div>自年初至本月汇计(万元)：{{schedule_sum_at_month_year}}</div>
    </div>
    <div class="fz-12 inline-block" style="vertical-align: -8px;margin-left:20px;">
      <div>尚未完成(万元)：{{schedule_unfinished}}</div>
      <div>本月完成(万元)：{{schedule_sum_at_month_total}}</div>
    </div>
  </div>
</template>
<script>
export default {
  iden: 'constructionSchedule',
  props: {
    selfData: {
      default() {
        return []
      }
    }
  },
  data() {
    return {
      totalList: [], // 获取选中数据
      schedule_size: 0, // 建筑面积（㎡）
      schedule_price: 0, // 工程造价（元）
      schedule_sum: 0, // 自开始建设至本月汇计完成（万元）
      schedule_sum_at_month_year: 0, // 自年初至本月汇计（万元）
      schedule_unfinished: 0, // 尚未完成（万元）
      schedule_sum_at_month_total: 0,// 本月完成（万元）
      tempDataList: {
        'project_size_': 'schedule_size',
        'project_cost_': 'schedule_price',
        'form_construction_schedule_sum': 'schedule_sum',
        'form_construction_schedule_sum_at_month_year': 'schedule_sum_at_month_year',
        'form_construction_schedule_unfinished': 'schedule_unfinished',
        'form_construction_schedule_sum_at_month_total': 'schedule_sum_at_month_total'
      }
    }
  },
  methods: {
    getSelfData() {
      let self = this
      let postData = {
        params: [
          {
            postArr: ['listConfig', 'multipleSelection'],
            fieldName: 'listMultipleSelection'
          },
          {
            postArr: ['listConfig', 'list_data'],
            fieldName: 'listData'
          }
        ]
      }
      this.$emit('getSelfData', postData)
      setTimeout(function() {
        // 重置所有数据
        self.resetData()
        // 获取表格数据或者选中数据
        let listMultipleSelection = _.cloneDeep(self.selfData['listMultipleSelection'])
        let listData = _.cloneDeep(self.selfData['listData'])
        if (_g.isRealEmpty(listMultipleSelection) || _g.isRealEmpty(listData)) {
          _g.toastMsg(self, 'warning', '请选择列表数据')
          return
        }
        _(listMultipleSelection).forEach((item) => {
          let temp = _.findIndex(listData, { id: item })
          if (temp !== -1) {
            self.totalList.push(listData[temp])
          }
        })
        _(self.totalList).forEach((item) => {
          _(self.tempDataList).forEach((value, key) => {
            if (!item[key]) {
              item[key] = '0'
            }
            // 正则匹配去除逗号-总金额
            let tempM = item[key].replace(/,/g, '')
            self[value] = _g.handleCompute(self[value], parseFloat(tempM), '+')
          })
        })
      }, 200)
    },
    resetData() {
      this.totalList = []
      this.schedule_size = 0 // 建筑面积（㎡）
      this.schedule_price = 0 // 工程造价（元）
      this.schedule_sum = 0 // 自开始建设至本月汇计完成（万元）
      this.schedule_sum_at_month_year = 0 // 自年初至本月汇计（万元）
      this.schedule_unfinished = 0 // 尚未完成（万元）
      this.schedule_sum_at_month_total = 0 // 本月
    }
  }
}
</script>




// WEBPACK FOOTER //
// constructionSchedule.vue?5cf3b990